/** @jsx jsx */

import React, { Fragment as _, memo, useContext } from 'react';
import { css, jsx } from '@emotion/core';
import EditableText from 'components/lib/EditableText';
import renderBlock from 'services/apiHelpers/renderBlock';
import { Row, Column } from '@chameleoncreator/creator-ui';
import Image from 'components/lib/Image';
import ContinueBtn from 'components/lib/ContinueBtn/continueBtn_v2';
import Container from 'components/Layouts/ContainerLogical';
import MultichoiceImage from './MultichoiceImage';
import Media from 'components/lib/Media';
import Video from 'components/lib/Video';
import Audio from 'components/lib/Audio';
import Transcript from 'components/lib/Video/Transcript';
import SVG from 'components/lib/SVG';
import Embed from 'components/lib/Embed';
import { interactionContext } from './interactionContext';
import { Block } from '@chameleoncreator/creator-app';
import getBlockById from 'services/apiHelpers/getBlockById';
import IELayout from 'components/Layouts/IELayout';
import shouldUpdate from 'services/shouldUpdate';
import PDF from 'components/lib/PDF';
import { OpenPDF } from 'components/lib/PDF/OpenPDF';
import { interactionContext as _interactionContext } from './interactionContext';
import MultiChoice_default from 'assets/Rectangle.png';
import Answer from './Answer';
import SubmitBtn from './SubmitBtn';
import Feedback from 'components/lib/Feedback/Feedback_updated_022022';

const SingleColumnLayout = Row.bind({}) as any;
SingleColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'column',
};

const TwoColumnLayout = Row.bind({}) as any;
TwoColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'row',
};

const Components = {
  Row,
  Column,
  Text: EditableText,
  InteractionColumn: ({ children }) => {
    return children?.[0] || null;
  },
  Image: ({ children, ...props }) => {
    const updatedProps = {
      ...props,
    };

    if (!props.src) {
      updatedProps.placeholder = MultiChoice_default;
    }

    return <Image {...{ ...updatedProps, usePlaceholderValue: true }} />;
  },
  TwoColumnLayout: TwoColumnLayout,
  SingleColumnLayout: SingleColumnLayout,
  ContinueButton: ContinueBtn,
  EditableButton: SubmitBtn,
  Video,
  Audio,
  Transcript: ({ children, props }) => {
    return children;
  },
  SVG,
  Embed,
  Media,
  MultichoiceImageWithText: MultichoiceImage,
  ColumnImageAndText: ({ children, ...props }) => {
    const interactionContext = useContext(_interactionContext);
    const { useMediaInColumn = true } = interactionContext.props;

    const [img, txt] = children;
    return useMediaInColumn ? children : txt;
  },
  //
  Answer,
  Feedback,
  Correct: ({ children, ...props }) => children,
  Incorrect: ({ children, ...props }) => children,
  Attempt: ({ children, ...props }) => children,
  PDF,
  OpenPDF,
  Modal: () => null,
  ...IELayout(interactionContext),
};

const MultichoiceImageDisplay = memo((props: any) => {
  const interactionBlock = getBlockById(props.blockId);

  const renderedChildren = (interactionBlock.children as Block[]).map(child => {
    return renderBlock(child, Components);
  });

  const defaultFeedback = renderedChildren[1];

  return (
    <Container
      id={interactionBlock.id}
      key={interactionBlock.id}
      {...interactionBlock.props}
      {...props}
    >
      <interactionContext.Provider
        value={{
          ...interactionBlock,
          updateItemsSeen: null,
          defaultFeedback,
        }}
      >
        {renderedChildren}
      </interactionContext.Provider>
    </Container>
  );
}, shouldUpdate as any);

export default MultichoiceImageDisplay;
